// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"531":"cde83701a196f216","934":"5eaa03c271785bad"}[chunkId] + ".js";
};